import { Components, Theme } from '@mui/material';

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
      borderRadius: '8px',
    }),
  },
};

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: '8px',
      padding: '4px 14px',
      textTransform: 'none',
      fontWeight: 500,
      border: 0,
      color: theme.palette.mode === 'light' ? theme.palette.text.primary : theme.palette.text.secondary,
      '&:hover': {
        backgroundColor:
          theme.palette.mode === 'light'
            ? `${theme.palette.grey[200]}80`
            : `${theme.palette.grey[700]}80`,
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '&.Mui-disabled': {
        border: 0,
      },
    }),
  },
};
